import { useCallback, useState } from 'react';

import { DropdownFieldEditorProps } from './DropdownFieldEditor.types';

export const useDropdownFieldEditor = (
    value: DropdownFieldEditorProps['value'],
    onSubmit: DropdownFieldEditorProps['onSubmit']
) => {
    const [valueInternal, setValueInternal] = useState(value || '');

    const handleSubmit = useCallback(() => {
        onSubmit(valueInternal);
    }, [onSubmit, valueInternal]);

    const handleOpen = useCallback(
        (open: boolean) => {
            open && setValueInternal(value);
        },
        [value]
    );

    return {
        valueInternal,
        handleOpen,
        handleSubmit,
        handleChange: setValueInternal,
    };
};
